import * as ROUTES from '@hotjar/webapp/constants/routes';

export const getPageType = (
  currentPathConfigName: string,
): 'setting' | 'profile' | 'feature' | 'onboarding' => {
  const currentSection = currentPathConfigName.split('.')[0];

  if (
    [
      ROUTES.SETTINGS.BASE.name,
      ROUTES.SITE.BASE.name,
      ROUTES.TEAM.BASE.name,
      ROUTES.SSO.BASE.name,
    ].includes(currentSection)
  ) {
    return 'setting';
  }

  if (currentSection === ROUTES.PROFILE.BASE.name) {
    return 'profile';
  }

  if ([ROUTES.OVERVIEW.SETUP.name, ROUTES.ONBOARDING.ONBOARDING.name].includes(currentSection)) {
    return 'onboarding';
  }

  return 'feature';
};
